import { render } from "./FirstLoginInstructions.vue?vue&type=template&id=74529da5&scoped=true"
import script from "./FirstLoginInstructions.vue?vue&type=script&lang=js"
export * from "./FirstLoginInstructions.vue?vue&type=script&lang=js"

import "./FirstLoginInstructions.vue?vue&type=style&index=0&id=74529da5&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74529da5"]])

export default __exports__